import {useDispatch, useSelector} from 'react-redux';
import {Input} from '~library/atoms/Input';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {SearchLineIcon} from '~library/svg/SearchLineIcon';
import './RecipientSearch.sass';
import {
  RECIPIENT_FILTER,
  selectRecipientFilter,
} from '~/CreateFabricGreetingCard/reducers/recipientsMessage';

export const RecipientSearchInput = ({onSearch}) => {
  const dispatch = useDispatch();
  const q = useSelector(selectRecipientFilter);

  return (
    <form className="recipient-search__search">
      {q
        ? <CloseLineIcon
            className="recipient-search__search-icon"
            onClick={() => {
              dispatch({type: RECIPIENT_FILTER, payload: ''});
              onSearch();
            }}
          />
        : <SearchLineIcon className="recipient-search__search-icon" />}

      <Input
        className="recipient-search__search-field"
        data-qa-id="search-recipients"
        placeholder="Search recipients"
        value={q}
        onChange={(e) => {
          dispatch({
            type: RECIPIENT_FILTER,
            payload: e.target.value,
          });
          onSearch();
        }}
      />
    </form>
  );
};
